import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import ListItemText from "@material-ui/core/ListItemText";
import withStyles from "components/with-styles";
import styles from "./styles/item-text.css.js";

const ItemText = ({ disabled, text, classes }) => (
  <ListItemText primary={text} className={cn({ [classes.disabled]: disabled })} />
);

ItemText.propTypes = {
  /**
   * Indica si la entrada de menú está deshabilitada
   **/
  disabled: PropTypes.bool,
  /**
   * Texto de la entrada de menú
   **/
  text: PropTypes.string,
};

export default withStyles(styles)(ItemText);
